<template>
  <bk-page class="changeSuccessfullyPage" pageType="navPage" :navBarInfo="navBarInfo" @close="handleConfirm">
    <bk-view class="view-changeSuccessfully-content">
      <bk-view class="view-icon"></bk-view>
      <bk-lang class="view-label" code="userInfo_updateEmail_changeSuccessfully"></bk-lang>
      <bk-button size="full" langCode="verify_btn_done" @click="handleConfirm"></bk-button>
    </bk-view>
  </bk-page>
</template>

<script>
  

	export default {
		name: 'changeSuccessfully',
		data (){
			return {
				navBarInfo: {
					backFlag: true,
				},
			};
		},	
    methods:{
      handleConfirm(){
        this.$emit('confirm')
      }
    }	
	};
</script>

<style lang="less">
@import './changeSuccessfully.less';
</style>